import { Box } from '@chakra-ui/react'
import React from 'react'

import {
  CircleBadgeVariant,
  useCircleBadgeStyle,
} from './componentStyles/CircleBadge.style'

interface CircleBadgeProps {
  variant: CircleBadgeVariant
}
export const CircleBadge = ({ variant }: CircleBadgeProps) => {
  const style = useCircleBadgeStyle({ variant })
  return <Box css={style} />
}
